import { DocumentData, Firestore, QuerySnapshot } from 'firebase/firestore';
import { typeUniqueId } from "../../../../dataObjects/types"
import { IFirestoreUserFeedbackRepository, FirestoreUserFeedbackRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreUserFeedbackRepository";
import { FirebaseAppSingleton } from "../../../cloudServices/googleFirebaseServices/FirebaseAppSingleton";
import { FirestoreDbContext } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDbContext";


export function getUserFeedbackForOwnerId_onSnapshot(ownerId: typeUniqueId, callback: (snapshot: QuerySnapshot<DocumentData>) => void): Promise<() => void> {
  return new Promise<() => void>(async (resolve, reject) => {
    try {
      // initialize a Firestore object instance
      const firestoreObj: Firestore = FirebaseAppSingleton.firestore;
      // instantiate a FirestoreDbContext
      const dbContext = new FirestoreDbContext('firestoreDb', firestoreObj);

      const firestoreUserFeedbackRepository: IFirestoreUserFeedbackRepository = new FirestoreUserFeedbackRepository(dbContext);

      // fetch the topics for the pertinent channelId
      const unsubscribeCallback: () => void = await firestoreUserFeedbackRepository.getAllForOwner_onSnapshot(ownerId, callback);

      resolve(unsubscribeCallback);
    }
    catch (error: any) {
      reject(error);
    }
  });
}